export const CAROUSEL_TYPES = {
  SLIDER: 'slider',
  CAROUSEL: 'carousel'
}
CAROUSEL_TYPES.ALL = Object.values(CAROUSEL_TYPES)

export const IMAGE_TRANSFORM_OPTIONS = {
  COVER: 'cover',
  CONTAIN: 'contain',
  AUTO: 'auto'
}

IMAGE_TRANSFORM_OPTIONS.ALL = Object.values(IMAGE_TRANSFORM_OPTIONS)

export const IMAGE_POSITION_OPTIONS = {
  LEFT_TOP: 'left top',
  LEFT_CENTER: 'left center',
  LEFT_BOTTOM: 'left bottom',
  CENTER_TOP: 'center top',
  CENTER_CENTER: 'center center',
  CENTER_BOTTOM: 'center bottom',
  RIGHT_TOP: 'right top',
  RIGHT_CENTER: 'right center',
  RIGHT_BOTTOM: 'right bottom'
}

IMAGE_POSITION_OPTIONS.ALL = Object.values(IMAGE_POSITION_OPTIONS)

export const TEXT_POSITION_TYPES = {
  TOP: 'top',
  FULL: 'middle',
  BOTTOM: 'bottom',
  BOTTOM_MARGIN: 'bottom-margin'
}
TEXT_POSITION_TYPES.PARTIAL = _.values([TEXT_POSITION_TYPES.TOP, TEXT_POSITION_TYPES.FULL, TEXT_POSITION_TYPES.BOTTOM])
TEXT_POSITION_TYPES.ALL = _.values([TEXT_POSITION_TYPES.TOP, TEXT_POSITION_TYPES.FULL, TEXT_POSITION_TYPES.BOTTOM, TEXT_POSITION_TYPES.BOTTOM_MARGIN])

export const TEXT_ALIGN_OPTIONS = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
}
TEXT_ALIGN_OPTIONS.ALL = Object.values(TEXT_ALIGN_OPTIONS)

export const VIDEO_PLATFORM_OPTIONS = {
  VIMEO: 'vimeo',
  YOUTUBE: 'youtube'
}
VIDEO_PLATFORM_OPTIONS.ALL = Object.values(VIDEO_PLATFORM_OPTIONS)

import { BUTTON_TYPES } from 'src/models/page/Section'

export const createCarousel = () => {
  return {
    controlsVisible: true,
    controlsType: BUTTON_TYPES.FLAT,
    controlsColor: 'default',
    controlsColorHex: '#FFFFFF',
    controlsBorderRadius: 4,
    paginationVisible: false,
    type: CAROUSEL_TYPES.CAROUSEL,
    title: null,
    showTitle: true,
    items: [],
    posterBorderRadius: 0,
    buttonType: BUTTON_TYPES.STANDARD,
    buttonColor: 'primary',
    buttonColorHex: '#FFFFFF',
    buttonBorderRadius: 4,
    spacing: 10,
    carouselWidth: 600,
    carouselHeight: 400,
    hasMobileCarouselHeight: false,
    mobileCarouselHeight: 400,
    sliderWidth: 400,
    sliderHeight: 600,
    imageTransformationType: IMAGE_TRANSFORM_OPTIONS.COVER,
    imagePositionType: IMAGE_POSITION_OPTIONS.CENTER_CENTER,
    textPositionType: TEXT_POSITION_TYPES.FULL,
    textAlignType: TEXT_ALIGN_OPTIONS.CENTER,
    slidesPerView: 5,
    centred: false,
    keepRatio: false,
    cleanImage: true
  }
}
